import React from 'react';
import { NumberInput, Group, Text, ActionIcon, Tooltip } from '@mantine/core';
import ClickableHelpText from './ClickableHelpText';

const theme = {
  background: { secondary: '#161B22' },
  border: { primary: '#374151' },
  text: { primary: '#F9FAFB' }
};

export interface GroupButton {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  color?: string;
}

interface MinMaxInputPairProps {
  label: string;
  helpText?: string;
  detailedInfo?: string;
  minValue?: number;
  maxValue?: number;
  onMinChange: (value: number | undefined) => void;
  onMaxChange: (value: number | undefined) => void;
  min?: number;
  max?: number;
  groupButtons?: GroupButton[];
  style?: React.CSSProperties; // добавляем кастомный стиль
}

const MinMaxInputPair: React.FC<MinMaxInputPairProps> = ({
  label, helpText, detailedInfo,
  minValue, maxValue, onMinChange, onMaxChange, min, max, groupButtons,
  style // новый проп
}) => {
  const minStr = minValue === undefined || minValue === null ? '' : minValue.toString();
  const maxStr = maxValue === undefined || maxValue === null ? '' : maxValue.toString();

  const handleMinChange = (value: string | number) => {
    if (value === '' || value === null) {
      onMinChange(null as any); // передаем null вместо undefined
    } else {
      const num = typeof value === 'number' ? value : parseFloat(value);
      onMinChange(isNaN(num) ? null as any : num);
    }
  };

  const handleMaxChange = (value: string | number) => {
    if (value === '' || value === null) {
      onMaxChange(null as any); // передаем null вместо undefined
    } else {
      const num = typeof value === 'number' ? value : parseFloat(value);
      onMaxChange(isNaN(num) ? null as any : num);
    }
  };

  return (
    <div style={{ marginBottom: '12px', ...style }}>
      <Group mb={4} align="center" justify="space-between">
        <Group align="center" gap={4}>
          <Text size="sm" fw={500}>{label}</Text>
          {helpText && (
            <ClickableHelpText 
              text={helpText} 
              detailedInfo={detailedInfo || helpText}
            />
          )}
        </Group>
        {groupButtons && groupButtons.length > 0 && (
          <Group align="center" gap={2}>
            {groupButtons.map((btn, idx) => (
              <Tooltip key={idx} label={btn.label} position="left" withArrow>
                <ActionIcon size="xs" variant="subtle" color={btn.color} onClick={btn.onClick}>
                  {btn.icon}
                </ActionIcon>
              </Tooltip>
            ))}
          </Group>
        )}
      </Group>
      <Group gap="xs" grow>
        <NumberInput
          placeholder="Min"
          value={minStr}
          onChange={handleMinChange}
          min={min}
          max={max}
          size="sm"
          styles={{
            input: {
              backgroundColor: theme.background.secondary,
              border: `1px solid ${theme.border.primary}`,
              color: theme.text.primary,
              minHeight: '32px',
              fontSize: '14px',
              textAlign: 'center'
            }
          }}
          hideControls 
        />
        <NumberInput
          placeholder="Max"
          value={maxStr}
          onChange={handleMaxChange}
          min={min}
          max={max}
          size="sm"
          styles={{
            input: {
              backgroundColor: theme.background.secondary,
              border: `1px solid ${theme.border.primary}`,
              color: theme.text.primary,
              minHeight: '32px',
              fontSize: '14px',
              textAlign: 'center'
            }
          }}
          hideControls 
        />
      </Group>
    </div>
  );
};

export default React.memo(MinMaxInputPair);
